import { useState, useMemo, useEffect, useRef } from "react";

import Select from 'react-select';
import Export from "../../../../assets/images/Exports.png";
import dlt from "../../../../assets/images/dlt.png";
import Face from "../../../../assets/images/user.png";
import blue_eye from '../../../../assets/images/blue_eye.svg';

import save from '../../../../assets/images/save.svg';
import { ReactComponent as EyeIcon } from "../../../../assets/images/slotplanning/Eye_Icon 1.svg";
import { ReactComponent as ArchiveIcon } from "../../../../assets/images/slotplanning/archive_icon.svg";
import { ReactComponent as Editicon } from "../../../../assets/images/icon_svg/pen_w_line.svg";

import tripstoday from '../../../../assets/images/slotplanning/tripstoday.svg';
import onpremises from '../../../../assets/images/slotplanning/onpremises.svg';
import inprogress from '../../../../assets/images/slotplanning/inprogress.svg';
import arriving from '../../../../assets/images/slotplanning/arriving.svg';

import { Badge, Row, Col, Form, Modal, Button, Tab, Tabs, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faXmark, faSave } from '@fortawesome/free-solid-svg-icons';

import TableGrid from "../../../../Components/common/TableGrid";
import { useSelector } from "react-redux";
import TableFilters from "../../../../Components/common/TableGrid/TableFilters";
import TableTabs from "../../../../Components/common/TableGrid/TableTabs";

import { CallApi, CommonModal, getTodayDateTime } from "../../../../Components/common/CommonFunctions";
import { toast } from 'react-toastify';

import { useDispatch } from "react-redux";
import { useGetCargoDamageForwardersQuery, useToggleSlotStatusMutation } from "../../../../redux/services/SPL";
import { clearAllTableFilters, onChangeFilters, onTabChange, clearSelectedRowsData } from "../../../../redux/features/table/tableSlice";
import CommonCard from "../../../../Components/common/CommonCard";
import Remarks from "../../../../Components/common/Remarks";
import Attachment from "../../../../Components/common/Attachment";
import TripModal from "../common/TripModal";

const AllTrips = () => {

  const isMounted = useRef(false);
  const [isIconClosed, setIsIconClosed] = useState(false);
  const debounceRef = useRef(null);
  const [tripInput, setTripInput] = useState("");
  const [warehouse, setWarehouse] = useState([]);
  const [edited, setEdited] = useState(false);
  const [confShow, setConfShow] = useState(false);
  const [smallModal, setSmallModal] = useState(false);
  const [modalForm, setModalForm] = useState();
  const [modalData, setModalData] = useState();
  const [org, setOrg] = useState([]);

  const initialFormData = { shipment: [], driver_image: Face }
  const [formData, setFormData] = useState(initialFormData);
  const [sendData, setSendData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalTab, setModalTab] = useState('Dt');
  const fileInputRef = useRef(null);
  const [disLoading, setDisLoading] = useState(false);


  const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);

  const buildFilterParams = (filtersObj) => {
    const entries = Object.entries(filtersObj);
    const params = {};

    if (!entries.length) return params;

    entries.forEach(([field, value], index) => {
      params[`filtervalue${index}`] = value;
      params[`filtercondition${index}`] = "CONTAINS";
      params[`filteroperator${index}`] = 0;
      params[`filterdatafield${index}`] = field;
    });

    params.filterscount = entries.length;

    return params;
  };

  const queryParams = useMemo(() => {
    const filterParams = buildFilterParams(filters);

    const params = {
      ...filterParams,
      pagenum: pageDetails.pagenum,
      pagesize: pageDetails.pagesize,
      recordstartindex: pageDetails.recordstartindex,
      recordendindex: pageDetails.recordendindex,
    };

    if (sortby?.sortdatafield) {
      params.sortdatafield = sortby.sortdatafield;
      params.sortorder = sortby.sortorder;
    }

    if (tab?.value && tab.value !== "all" && tab.key) {
      params[tab.key] = tab.value;
    }
    return params;
  }, [filters, pageDetails, sortby]);

  const { data: myData, isFetching, refetch } = useGetCargoDamageForwardersQuery(queryParams, {
    skip: pageDetails.pagesize === 0,
    refetchOnMountOrArgChange: true,
  });

  const fetchWarehousOrgnaziation = async () => {
    CallApi({
      endPoint: `trip-management/slot-warehouse-organizations`,
      method: 'get',
      onSuccess: (res) => {
        const innerData = res.data.response_data;
        setOrg(innerData?.organization);
        setWarehouse(innerData?.warehouses);
      },
      onError: (msg) => toast.error(msg)
    });
  };
  const handleModalClose = () => {
    if (edited) {
      setConfShow(true)
    } else {
      setShowModal(false);
      setFormData(initialFormData);
    }
  }
  const confClose = () => {
    setConfShow(false)
    setEdited(false)
    setShowModal(false);
    setFormData(initialFormData);
  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }))
    setEdited(true)
  }
  const handleSave = () => {
    CallApi({
      endPoint: `trip-management/update-slot/${formData.id}`,
      method: 'patch',
      payload: formData,
      onSuccess: (res) => {
        const resCode = res.data.response_code;
        if (resCode === 200) {
          const innerData = res.data.response_data;
          if (confShow) {
            setConfShow(false)
          }
          setEdited(false)
          setShowModal(false);
          refetch()
        }
      },
      onError: (msg) => toast.error(msg)
    });


  }
  const handleModalTabChange = (tab) => {
    setModalTab(tab);
  }
  const handleProfileImageChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onloadend = () => {
      const base64 = reader.result;
      setFormData((prev) => {
        const updatedForm = {
          ...prev,
          driver_image: base64,
        };
        return updatedForm;
      });
    };

    reader.readAsDataURL(file);
  };

  const cards = [
    { icon: 'tripstoday', title: 'Trips Today', value: myData?.tripsToday },
    { icon: 'arriving', title: 'Arriving (Next 8h)', value: myData?.arrivingNext8Hours },
    { icon: 'inprogress', title: 'Arrived', value: myData?.arrivedCount },
    { icon: 'inprogress', title: 'Office In', value: myData?.officeInCount },
    { icon: 'onpremises', title: '(Un)Loading In Progress', value: myData?.loadingInProgressCount },
  ] 
  const iconMap = { tripstoday, onpremises, inprogress, arriving, };
  useEffect(() => {
    if (isMounted.current) return;
    fetchWarehousOrgnaziation();
    dispatch(onTabChange({ key: 'tab', value: "A" }));
    isMounted.current = true;
  }, []);

  const filtersConfig = [
    {
      type: "input",
      field: "trip_no",
      placeholder: "Search Trip No.",
    },
    {
      type: "multiselect",
      field: "warehouse_id",
      placeholder: "Warehouse",
      options: warehouse?.map((item) => ({
        label: item.name,
        value: item.id,
      })) || [],
    },
    {
      type: "multiselect",
      field: "org_id",
      placeholder: "Organization",
      options: org?.map((item) => ({
        label: item.org_Name,
        value: item.org_Key,
      })) || [],
    },
  ];
  const tabsConfig = [
    { label: "All", value: "all", paramKey: null },
    { label: "Open", value: "A", paramKey: "tab" },
    { label: "Archive", value: "R", paramKey: "tab" },
  ];

  const dispatch = useDispatch();

  const handleResetFilters = () => {
    dispatch(clearAllTableFilters(true));
    setTripInput('');
  };

  const handleCollapse = (value) => {
    setIsIconClosed(value);
  };


  const hasFilters = Object.values(filters).some(
    (value) => value && value.toString().trim() !== ""
  );

  const [toggleSlotStatus, { isLoading: archiveLoading }] = useToggleSlotStatusMutation();

  const handleArchive = async (rows) => {
    try {
      const ids = rows.map((r) => r.id);
      await toggleSlotStatus({ ids: ids }).unwrap();
      toast.success("Status updated");
      refetch();
      dispatch(clearSelectedRowsData(true));
    } catch (err) {
      toast.error("Updation failed");
    }
  };

  const transformedRows = useMemo(() => {
    return (
      myData?.Rows?.map((item) => {
        let timeslot = "";
        if (item?.slot_start_time && item?.slot_end_time) {
          const [, startTimeFull] = item.slot_start_time.split(" ");
          const [, endTimeFull] = item.slot_end_time.split(" ");
          const startTime = startTimeFull.slice(0, 5);
          const endTime = endTimeFull.slice(0, 5);
          timeslot = `${startTime} - ${endTime}`;
        }
        return {
          ...item,
          planned_date_time: item.planned_date_time
            ? item.planned_date_time.slice(0, 16)
            : "",
          timeslot,
        };
      }) || []
    );
  }, [myData]);

  const loadDetails = (uldNumber, pos) => {
    setSendData({ id: uldNumber, ps: pos })
    setShowModal(true)
    // setDisLoading(true);
    // CallApi({
    //   endPoint: `trip-management/get-slot-details/${uldNumber}`,
    //   // payload: { id: uldNumber },
    //   onSuccess: (data) => {
    //     const resCode = data.data.response_code;
    //     if (resCode === 200) {
    //       const innerData = data.data.response_data;
    //       if (pos === 'V') {
    //         setShowModal(true)
    //         setFormData({
    //           ...innerData,
    //           timeslot_booked: getTodayDateTime(innerData.created_at),
    //           driver_image: innerData?.driver_image ?? initialFormData.driver_image,
    //           gate_in: innerData?.gate_in?.split(' ')[0] + ' ' + innerData?.gate_in?.split(' ')[1].substring(0, 5)
    //         });
    //         setSendData({ attType: 'all_trip', id: innerData.id })
    //       }
    //       // else {
    //       //   setSelectedRowData(innerData);
    //       // }
    //     }
    //     setDisLoading(false);
    //   },
    //   onError: (msg) => { toast.error(msg); setDisLoading(false); }
    // });
  };

  const columns = [
    {
      label: "", field: "actions", enableSearch: false, cls: 'single_action',
      renderCell: (row) => (<div className="tb_grid_actions">
        <EyeIcon className="row_view" style={{ cursor: "pointer" }}
          onClick={(e) => {
            e.stopPropagation();
            loadDetails(row.id, "V");
          }}
        />
      </div>),
    },
    { label: "Trip No", field: "trip_no", enableSearch: false, cls: 'tw-8' },
    { label: "Organization", field: "org_name", enableSearch: false, cls: 'tw-8' },
    { label: "Truck No", field: "truck_nos", enableSearch: false, cls: 'tw-8' },
    {
      label: "Status", field: "status_type", enableSearch: false, cls: 'tw-7',
      renderCell: (row) => {
        const status = row.status_type;
        return (
          <div className={`status ${status === "Open" ? "bg-gry" : status === "Completed" ? "bgc-grn" : "bgc-org"}`}>
            <span className="stat-txt">{status}</span>
          </div>
        );
      },
    },
    {
      label: "Trip Status", field: "trip_status_name", enableSearch: false, cls: 'tw-10',
      renderCell: (row) => {
        const status = row.trip_status_name;
        return (
          <div className={``}>
            <span className="stat-txt">{status}</span>
          </div>
        );
      },
    },
    { label: "Trip Type", field: "trip_type", enableSearch: false, cls: 'tw-6' },
    { label: "Planned Time", field: "planned_date_time", enableSearch: false, cls: 'tw-7' },
    // { label: "Slot Date",   field: "slot_date", enableSearch: false, cls: 'tw-6' },
    // { label: "Start Time",  field: "slot_start_time", enableSearch: false, cls: 'tw-10' },
    // { label: "End Time",    field: "slot_end_time", enableSearch: false, cls: 'tw-10' },
    { label: "Timeslot", field: "timeslot", enableSearch: false, cls: 'tw-6' },
    { label: "Door", field: "door_no", enableSearch: false, cls: 'tw-5' },
    { label: "Warehouse", field: "warehouse_name", enableSearch: false },
    {
      label: "Office In", field: "office_in", enableSearch: false,
      renderCell: (row) => (
        <div className="">
          {row.office_in ?
            <>
              {row.office_in.slice(0, 16)}
              <Editicon
                onClick={(e) => {
                  e.stopPropagation();
                  setModalData({ ...row, mode: 'Update', title: 'Office In', form_name: 'office_in' })
                  setModalForm(row.office_in)
                  setSmallModal(true)
                }}
                style={{ cursor: "pointer", marginLeft: "5px" }}
              />
            </>
            :
            <button className="edit_btn" onClick={(e) => {
              e.stopPropagation();
              setModalData({ ...row, mode: 'Set', title: 'Office In', form_name: 'office_in' })
              setModalForm(getTodayDateTime());
              setSmallModal(true)
            }}>
              Check In
            </button>
          }

        </div>
      ),
    },
    {
      label: "Start (Un)Loading", field: "start_loading", enableSearch: false,
      renderCell: (row) => (
        <div className="">
          {row.start_loading ?
            <>
              {row.start_loading.slice(0, 16)}
              <Editicon
                onClick={(e) => {
                  e.stopPropagation();
                  setModalData({ ...row, mode: 'Update', title: 'Start (Un)Loading', form_name: 'start_loading' })
                  setModalForm(row.start_loading)
                  setSmallModal(true)
                }}
                style={{ cursor: "pointer", marginLeft: "5px" }}
              />
            </>
            :
            <button className="edit_btn" onClick={(e) => {
              e.stopPropagation();
              setModalData({ ...row, mode: 'Set', title: 'Start (Un)Loading', form_name: 'start_loading' })
              setModalForm(getTodayDateTime())
              setSmallModal(true)
            }}>
              Start
            </button>
          }

        </div>
      ),
    },
    {
      label: "End (Un)Loading", field: "end_loading", enableSearch: false,
      renderCell: (row) => (
        <div className="">
          {row.end_loading ?
            <>
              {row.end_loading.slice(0, 16)}
              <Editicon
                onClick={(e) => {
                  e.stopPropagation();
                  setModalData({ ...row, mode: 'Update', title: 'End (Un)Loading', form_name: 'end_loading' })
                  setModalForm(row.end_loading)
                  setSmallModal(true)
                }}
                style={{ cursor: "pointer", marginLeft: "5px" }}
              />
            </>
            :
            <button className="edit_btn" onClick={(e) => {
              e.stopPropagation();
              setModalData({ ...row, mode: 'Set', title: 'End (Un)Loading', form_name: 'end_loading' })
              setModalForm(getTodayDateTime())
              setSmallModal(true)
            }}>
              End
            </button>
          }

        </div>
      ),
    },
    {
      label: "Office Out", field: "office_out", enableSearch: false,
      renderCell: (row) => (
        <div className="">
          {row.office_out ?
            <>
              {row.office_out.slice(0, 16)}
              <Editicon
                onClick={(e) => {
                  e.stopPropagation();
                  setModalData({ ...row, mode: 'Update', title: 'Office Out', form_name: 'office_out' })
                  setModalForm(row.office_out)
                  setSmallModal(true)
                }}
                style={{ cursor: "pointer", marginLeft: "5px" }}
              />
            </>
            :
            <button className="edit_btn" onClick={(e) => {
              e.stopPropagation();
              setModalData({ ...row, mode: 'Set', title: 'Office Out', form_name: 'office_out' })
              setModalForm(getTodayDateTime())
              setSmallModal(true)
            }}>
              Check In
            </button>
          }

        </div>
      ),
    },
    // checkbox col takes remaining ~3% automatically via the fixed <th> in Table
  ];

  const bulkActions = tab?.value === "A"
    ? [{ label: "Archive", action: handleArchive, icon: ArchiveIcon }]
    : tab?.value === "R"
      ? [{ label: "Activate", action: handleArchive, icon: ArchiveIcon }]
      : [];

  // const smallModalOpen = () => {
  //   setSmallModal(true)
  // }
  const smallModalClose = () => {
    setSmallModal(false)
  }
  const smallModalSave = () => {
    CallApi({
      endPoint: `trip-management/update-slot/${modalData.id}`,
      method: 'patch',
      payload: { [modalData?.form_name]: modalForm },
      onSuccess: (res) => {
        const resCode = res.data.response_code;
        if (resCode === 200) {
          toast.success(res.data.response_msg)
          setSmallModal(false)
          refetch()
        } else {
          toast.error(res.data.response_msg)
        }
      },
      onError: (msg) => toast.error(msg)
    });
  }

  return (
    <>
      {/* {console.log("formData", formData)} */}
      {disLoading ? <div className='mvt loader-container h-100'><span className='mvt loader' style={{ left: '48%', top: '48%' }}></span></div> : ''}
      <div className="main-content">
        {cards?.length ?
          <div className="card-bx">
            {cards?.map((item, index) => (
              <CommonCard icon={iconMap[item.icon]} title={item.title} value={item.value} btn={item.btn} />
            ))}
          </div>
          : <></>
        }
        <div className="d-flex justify-content-between align-items-center mb-3">
          <TableFilters filtersConfig={filtersConfig} />
          <TableTabs tabs={tabsConfig} />
        </div>

        <div>
          <TableGrid
            columns={columns}
            rows={transformedRows}
            checkboxSelection={true}
            totalRecords={myData?.TotalRows || 0}
            onClickRow={(row) => {
              console.log("Clicked Row:", row);
            }}
            loading={isFetching}
            bulkActions={bulkActions}
            rowKey="id"
          />
        </div>
      </div>
      <CommonModal
        show={confShow}
        onHide={confClose}
        title='Unsaved Changes'
        className='addfrom slot_conf'
        footer={
          <div className='d-flex justify-content-between are_bottom'>
            <Button variant="secondary" onClick={confClose}>
              <FontAwesomeIcon icon={faXmark} /> Don't Save
            </Button>
            <Button variant="primary" onClick={handleSave}>
              <FontAwesomeIcon icon={faSave} /> Save
            </Button>
          </div>
        }>
        <p>You have made changes that have not been saved.<br />If you continue, all unsaved changes will be lost.</p>
      </CommonModal>
      {showModal &&
        <TripModal propData={sendData} show={showModal} onHide={() => setShowModal(false)} />
      }
      <CommonModal
        show={smallModal}
        onHide={smallModalClose}
        title={modalData?.mode + ' ' + modalData?.title}
        subTitle='Update the milestone timestamp'
        className='modal_bgw primary_modal'
        footer={
          <div className='d-flex justify-content-between w-100 m-0'>
            <Button variant="secondary" onClick={smallModalClose}>
              <FontAwesomeIcon icon={faXmark} /> {modalData?.mode === 'Set' ? 'Cancel' : 'Clear'}
            </Button>
            <Button variant="primary" onClick={smallModalSave}>
              <FontAwesomeIcon icon={faSave} /> {modalData?.mode + ' ' + modalData?.title}
            </Button>
          </div>
        }>
        <Form.Group className='w-50 mb-2'>
          <Form.Label>{modalData?.title} <span className='red'></span></Form.Label>
          <Form.Control
            type='datetime-local'
            placeholder=""
            name={modalData?.form_name}
            value={modalForm || ''}
            onChange={(e) => setModalForm(e.target.value)}
          />
        </Form.Group>
      </CommonModal>
    </>
  )
}

export default AllTrips